import { Grid } from '@mui/material';
import { Filter } from '@tassat/icon';
import * as React from 'react';

import muiStyles from './styles';
import { FilterMenuItemProps } from './types';

export default function FilterMenuItem(props: FilterMenuItemProps) {
    const {
        option,
        currentModel
    } = props;

    const { icon } = muiStyles(props);

    const filterIcon = React.useMemo(() => {
        if (!currentModel || !option) {
            return null;
        }

        if (
            currentModel.colId === option.colId &&
            currentModel.filter === option.filter &&
            currentModel.type === option.type
        ) {
            return <Filter />;
        }

        return null;
    }, [ currentModel, option ]);

    return (
        <Grid
            container
            justifyContent='space-between'
        >
            <Grid
                item
                xs={10}
            >
                {option.title}
            </Grid>
            <Grid
                className={icon}
                item
                xs={2}
            >
                {filterIcon}
            </Grid>
        </Grid>
    );
}